import { Action } from 'redux';

export const GET_OTC_ORDER_OPTIONS = 'otc/GET_OTC_ORDER_OPTIONS';
export interface GetOTCOrderOptionsAction extends Action<typeof GET_OTC_ORDER_OPTIONS> {
  readonly meta: ActionMetaData;
}

export const getOTCOrderOptions = (meta: ActionMetaData = {}): GetOTCOrderOptionsAction => ({
  meta,
  type: GET_OTC_ORDER_OPTIONS,
});

export const PERSIST_OTC_ORDER_OPTIONS = 'otc/PERSIST_OTC_ORDER_OPTIONS';
export interface PersistOTCOrderOptionsAction extends Action<typeof PERSIST_OTC_ORDER_OPTIONS> {
  readonly payload: {
    readonly options: OrderOptions;
  };
}

export const persistOTCOrderOptions = (options: OrderOptions): PersistOTCOrderOptionsAction => ({
  payload: {
    options,
  },
  type: PERSIST_OTC_ORDER_OPTIONS,
});

export const CREATE_OTC_ORDER = 'otc/CREATE_ORDER';
export interface CreateOTCOrderAction extends Action<typeof CREATE_OTC_ORDER> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly order: CreateOrderRequest;
  };
}

export const createOTCOrder = (order: CreateOrderRequest, meta: ActionMetaData = {}): CreateOTCOrderAction => ({
  meta,
  payload: {
    order,
  },
  type: CREATE_OTC_ORDER,
});

export const GET_OTC_ORDER_DRIVER = 'otc/GET_OTC_DRIVER';
export interface GetOTCOrderDriverAction extends Action<typeof GET_OTC_ORDER_DRIVER> {
  readonly meta: ActionMetaData;
  readonly payload: {
    readonly id: number;
  };
}

export const getOTCOrderDriver = (id: number, meta: ActionMetaData = {}): GetOTCOrderDriverAction => ({
  meta,
  payload: {
    id,
  },
  type: GET_OTC_ORDER_DRIVER,
});

export const PERSIST_OTC_ORDER_DRIVER = 'otc/PERSIST_OTC_ORDER_DRIVER';
export interface PersistOTCOrderDriverAction extends Action<typeof PERSIST_OTC_ORDER_DRIVER> {
  readonly payload: {
    readonly driver: DriverAccount;
  };
}

export const persistOTCOrderDriver = (driver: DriverAccount) => ({
  payload: {
    driver,
  },
  type: PERSIST_OTC_ORDER_DRIVER,
});

export const RESET_OTC_ORDER = 'otc/RESET_OTC_ORDER';
export interface ResetOTCOrderAction extends Action<typeof RESET_OTC_ORDER> {}

export const resetOTCOrder = () => ({
  type: RESET_OTC_ORDER,
});

/**
 * Shopping Cart
 */
export const EMPTY_CART = 'otc/EMPTY_CART';
export interface EmptyCartAction extends Action<typeof EMPTY_CART> {}
export const emptyCart = (): EmptyCartAction => ({
  type: EMPTY_CART,
});

export const ADD_TO_CART = 'otc/ADD_TO_CART';
export interface AddToCartAction extends Action<typeof ADD_TO_CART> {
  readonly payload: {
    readonly item: ShoppingCartItem;
  };
}
export const addToCart = (item: ShoppingCartItem): AddToCartAction => ({
  payload: {
    item,
  },
  type: ADD_TO_CART,
});

export const REMOVE_FROM_CART = 'otc/REMOVE_FROM_CART';
export interface RemoveFromCartAction extends Action<typeof REMOVE_FROM_CART> {
  readonly payload: {
    readonly item: ShoppingCartItem;
  };
}
export const removeFromCart = (item: ShoppingCartItem): RemoveFromCartAction => ({
  payload: {
    item,
  },
  type: REMOVE_FROM_CART,
});

export const SET_CUSTOMER_INFORMATION = 'otc/SET_CUSTOMER_INFORMATION';
export interface SetCustomerInformationAction extends Action<typeof SET_CUSTOMER_INFORMATION> {
  readonly payload: {
    readonly info: OTCPersonalInformation;
  };
}
export const setCustomerInformation = (info: OTCPersonalInformation): SetCustomerInformationAction => ({
  payload: {
    info,
  },
  type: SET_CUSTOMER_INFORMATION,
});

export const SET_CART_PAYMENT = 'otc/SET_CART_PAYMENT';
export interface SetCartPaymentAction extends Action<typeof SET_CART_PAYMENT> {
  readonly payload: {
    readonly payment?: OTCPaymentRequest;
  };
}
export const setCartPayment = (payment?: OTCPaymentRequest): SetCartPaymentAction => ({
  payload: {
    payment,
  },
  type: SET_CART_PAYMENT,
});

export type OTCAction =
  | EmptyCartAction
  | AddToCartAction
  | RemoveFromCartAction
  | SetCustomerInformationAction
  | SetCartPaymentAction
  | GetOTCOrderOptionsAction
  | PersistOTCOrderOptionsAction
  | CreateOTCOrderAction
  | GetOTCOrderDriverAction
  | PersistOTCOrderDriverAction
  | ResetOTCOrderAction;
